import { AudioContext } from './AudioProvider';
import { AudioContextShape } from './models/AudioContextShape';
import { useContext, useEffect, useRef } from 'react';

export default function HallowAudio({ audioUrl }) {
    const ref = useRef<HTMLAudioElement>(null);
    const audio = useContext<AudioContextShape>(AudioContext);
    const handleInitial = () => {
        audio.setState({
            duration: ref.current.duration,
            paused: ref.current.paused,
            pause: () => ref.current.pause(),
            play: () => ref.current.play(),
            currentTime: ref.current.currentTime,
            setCurrentTime: (time) => { ref.current.currentTime = time; },
            loading: false
        });
    };
    
    const handleChange = () => {
        audio.setState({
            ...audio.state,
            duration: ref.current.duration
        });
    };
    
    const handlePlay = () => {
        audio.setState({
            ...audio.state,
            paused: false
        });
    };
    
    const handlePause = () => {
        audio.setState({
            ...audio.state,
            paused: true
        });
    };
    
    const handleProgress = () => {
        audio.setState({
            ...audio.state,
            currentTime: ref.current.currentTime
        });
    };
    
    useEffect(() => {
        if (!audio.state.duration) {
            audio.setState({
                ...audio.state,
                loading: true
            });
        }
    }, []);
    
    
    return <audio ref={ref} src={audioUrl} onPlay={handlePlay} onPause={handlePause} onTimeUpdate={handleProgress} onCanPlayThrough={handleInitial} onCanPlay={handleInitial} onDurationChange={handleChange} />;
}